module.exports = __webpack_public_path__ + "static/media/10-5.35bfe98c.mp3";